<template>
    <div class="text-base">
        <h6 v-show="showPayments" class="font-bold mb-3">Tipo de pagamento</h6>
        <ul v-show="showPayments">
            <li
                v-for="item in paymentList" :key="item.value"
                class="flex items-center cursor-pointer py-1">
                <vs-checkbox v-model="item.checked" class="ml-0">{{ item.description }}</vs-checkbox>
            </li>
        </ul>
   
        <vs-divider v-show="showPayments" />

        <h6 class="font-bold mb-4">Data</h6>

        <div class="vx-col sm:w-full">
            <span class="vx-col">Data inicial</span>
            <DatePicker format="dd/MM/yyyy" v-model="pickerDate.from"></DatePicker>
        </div>
        
        <div class="vx-col sm:w-full mt-2">
            <span class="vx-col">Data final</span>
            <DatePicker format="dd/MM/yyyy" v-model="pickerDate.to"></DatePicker>
        </div>

    </div>
</template>

<script>
    import {mask} from 'vue-the-mask'
    import moment from 'moment';
    import DatePicker from '../../components/DatePicker';
    var timeout = 0;

    export default {
        props: {
            showPayments: Boolean,
            dates: Object,
            skipRangeValidation: Boolean
        },
        components: {
            DatePicker
        },
        directives : {mask},
        watch: {
            filters (val) {
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    this.$emit('filter', val);
                }, 1000);
            },
            dates: {
                handler (val) {
                    this.pickerDate = val;
                },
                deep: true
            },
            pickerDate: {
                handler (val) {
                    this.handleChange(val);
                },
                deep: true
            }
        },
        data() {
            return {
                payments: {
                    cash: { id: 'money', description: 'Dinheiro', checked: false },
                    cardCredit: { id: 'card_credit', description: 'Crédito', checked: false },
                    cardDebit: { id: 'card_debit', description: 'Débito', checked: false },
                    picpay: { id: 'picpay', description: 'Picpay', checked: false } 
                },
                date : {
                    from: moment().subtract(1, 'day').toDate(),
                    to: new Date()
                },
                pickerDate: {
                    from: moment().subtract(1, 'day').toDate(),
                    to: new Date()
                }
            }
        },
        computed: {
            filters () {
                const paymentTypes = this.paymentList
                        .filter(p => p.checked)
                        .map(p => p.id);
                const date = this.dateFilter;
                return { paymentTypes, date };
            },
            from () { return moment(this.pickerDate.from); },
            to () { return moment(this.pickerDate.to); },
            dateFilter () {
                const date = {};
                if (this.to.isValid()) {
                    date.to = this.to.endOf('day').toDate();
                }
                if (this.from.isValid())
                    date.from = this.from.toDate();
                return (date.to || date.from) ? date : null
            },
            paymentList() {
                return Object.values(this.payments);
            },
            fromValidationError () { return (this.date.from &&  (!this.from.isValid() && 'Data inválida') || ((this.from.toDate() > (this.to && this.to.toDate())) && 'Data inicio deve ser inferior')) || '' },
            toValidationError () { return (this.date.to && !this.to.isValid() && 'Data inválida') || '' },
        },
        methods: {
            handleChange (val) {
                if (!val || !val.from || !val.to)
                    return;
                const isValidRange = this.skipRangeValidation || this.checkRange(val);
                if (!isValidRange) {
                    this.$nextTick(() => {
                        this.pickerDate = {
                            from: val.from,
                            to: moment(val.from).add(7, 'day').toDate(),
                        };
                    });
                    return;
                }
                if (val.from > val.to) {
                    this.$nextTick(() => {
                        this.pickerDate = {
                            from: val.to,
                            to: val.to,
                        };
                    });
                    return;
                }
                this.date.from = val.from;
                this.date.to = val.to;
            },
            checkRange (val) {
                var duration = moment.duration(moment(val.to).diff(val.from));
                const isValid = duration.asDays() <= 8;
                if (!isValid)
                    this.$warning({
                        zIndex: 99999,
                        title: 'Intervalo muito longo',
                        content: 'Intervalo de datas deve ser inferior a 1 (uma) semana. Um intervalo menor foi selecionado'
                    });
                return isValid;
            }
        },
        created () {
            this.$emit('filter', this.filters);
        }
    }
</script>

<style lang="scss" scoped>
 
  .algolia-price-slider {
    min-width: unset;
  }

  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
    min-width: 50%;
  }

  .item-view-secondary-action-btn {
    min-width: 50%;
  }

</style>